import { Link } from "react-router-dom";

const foodLinks = [
  { label: "中餐精选", to: "/food-category" },
  { label: "西餐烘焙", to: "/food-category" },
  { label: "甜点饮品", to: "/food-category" },
  { label: "招牌牛肉面", to: "/food-detail/beef-noodle" },
];

const courierLinks = [
  { label: "快递服务", to: "/courier" },
  { label: "立即寄件", to: "/courier-send" },
  { label: "快递查询", to: "/courier-track" },
  { label: "保价与理赔", to: "/courier" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "发展历程", to: "/about" },
  { label: "联系方式", to: "/contact" },
  { label: "在线留言", to: "/contact" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-video-line", label: "短视频" },
  { icon: "ri-phone-line", label: "电话" },
];

export default function Footer() {
  return (
    <footer className="mt-auto bg-primary-950 text-primary-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-5 lg:py-16">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-e-bike-2-fill text-xl" />
            </span>
            <span className="font-heading text-lg font-extrabold text-background-50">美味的快递</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200">
            一站式美食外卖与同城快递服务平台，严选美食资源、极速配送，让每一份美味与心意都准时抵达。
          </p>
          <div className="mt-5 flex gap-3">
            {socials.map((s) => (
              <button
                key={s.label}
                type="button"
                aria-label={s.label}
                className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-900 text-primary-100 transition hover:bg-primary-500 hover:text-background-50"
              >
                <i className={`${s.icon} text-lg`} />
              </button>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">美食导览</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {foodLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-primary-200 transition hover:text-background-50">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">快递服务</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {courierLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-primary-200 transition hover:text-background-50">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-background-50">关于与帮助</h4>
          <ul className="flex flex-col gap-2.5 text-sm">
            {aboutLinks.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-primary-200 transition hover:text-background-50">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-2 px-4 py-5 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© 2026 美味的快递 · 优质美食外卖与快速快递服务平台 · 京ICP备 2026001234 号</p>
          <p>本站为前端演示站点，下单、寄件与查询结果均为演示内容</p>
        </div>
      </div>
    </footer>
  );
}